import React, { useState, useEffect } from 'react'
import { Row, Col, Typography, Card } from 'antd'
import AliceCarousel from 'react-alice-carousel'
import { HeaderHero, SEO } from './components'
import { ROADSIDE_ASSISTANCE_BREAK_POINTS, ROADSIDE_ASSISTANCE_ARRAY } from '../constants'
import { useWindowSize } from '../utils'

import RoadsideStyle from '../../styles/RoadsideAssistance.module.css'
import 'react-alice-carousel/lib/alice-carousel.css'

const tabletImage = 'hero/rsa/RSA_1024x300-no-copy.jpg'
const desktopImage = 'hero/rsa/RSA_1440x300-no-copy.jpg'
const largeScreenImage = 'hero/rsa/RSA_1620x300-no-copy.jpg'
const xtraLargeScreenImage = 'hero/rsa/RSA_1960x300-no-copy.jpg'
const smallImage = 'hero/rsa/RSA_375x188.jpg'
const smallImage390 = 'hero/rsa/RSA_390x188.jpg'
const mobileImage = 'hero/rsa/RSA_428x188.jpg'
const mobileImage768 = 'hero/rsa/RSA_768x300-no-copy.jpg'

const { Link, Text, Title } = Typography

const RoadsideAssistanceContent = ({ state }) => {
  //const [selectedState, setSelectedState] = useState("")
  const windowSize = useWindowSize()
  const [list, setList] = useState()
  const handleDragStart = e => e.preventDefault()
  useEffect(() => {
    if (!list) {
      const list = ROADSIDE_ASSISTANCE_ARRAY.map(({ index, className, title, description }) => (
        <Col key={index} className={`${RoadsideStyle["padding-0-col"]}`} onDragStart={handleDragStart}>
          <div className={`${RoadsideStyle["road-side-carousal-item"]}`}>
            <div className={`${RoadsideStyle[className]}`} />
            <Title className={`${RoadsideStyle["roadside-carousal-title"]}`} level={4}>
              {title}
            </Title>
            <Text className={`${RoadsideStyle["description"]}`}>{description}</Text>
          </div>
        </Col>
      ))
      setList(list)
    }
  }, [])

  const getFullState = (state) => {
    if (state === "PA") {
      return "Pennsylvania"
    }
    else if (state === "MI") {
      return "Michigan"
    }
    else if (state === "NJ") {
      return "New Jersey"
    }
  }

  const getDocumentLink = () => {
    if (state === "PA") {
      return "https://assets.cure.com/pdf/forms/4.2%20Clean%20PAC-RAC%2004-24.pdf"
    }
    else if (state === "MI") {
      return "https://assets.cure.com/pdf/forms/Clean%20%20MIC-RAC%2004-24.pdf"
    }
    else if (state === "NJ") {
      return "https://assets.cure.com/pdf/forms/NJC-RAC-04-24.pdf"
    }
  }

  const isMobile = windowSize.width > 1024
  var descriptionFull = "When the unexpected happens, you're covered 24/7 with CURE Roadside Assistance. Claims support 24/7 for NJ, PA & MI drivers."
  var urlName = "/roadside";
  var titleName = "Roadside Assistance | CURE Auto Insurance";

  switch (state) {
    case "PA":
      urlName = "/roadside/pa";
      titleName = "Pennsylvania Roadside Assistance | CURE Auto Insurance";
      descriptionFull = "When the unexpected happens, you're covered 24/7 with CURE Roadside Assistance. Claims support 24/7 for PA drivers.";
      break;
    case "MI":
      urlName = "/roadside/mi";
      titleName = "Michigan Roadside Assistance | CURE Auto Insurance";
      descriptionFull = "When the unexpected happens, you're covered 24/7 with CURE Roadside Assistance. Claims support 24/7 for MI drivers.";
      break;
    case "NJ":
      urlName = "/roadside/nj";
      titleName = "New Jersey Roadside Assistance | CURE Auto Insurance";
      descriptionFull = "When the unexpected happens, you're covered 24/7 with CURE Roadside Assistance. Claims support 24/7 for NJ drivers.";
      break;
    default:
      break;
  }

  return (
    <>
      <SEO
        description={descriptionFull}
        title={titleName}
        url={urlName}
      />
      <HeaderHero
        desktopImage={desktopImage}
        largeScreenImage={largeScreenImage}
        mobileImage={mobileImage}
        mobileImage768={mobileImage768}
        smallImage={smallImage}
        smallImage390={smallImage390}
        tabletImage={tabletImage}
        title="ROADSIDE ASSISTANCE"
        xtraLargeScreenImage={xtraLargeScreenImage}
      />
      <>
        <div className={`${RoadsideStyle["roadside-assistance-screen"]} page-text-margin`}>
          <Col lg={{ span: 24 }} md={{ span: 0 }} sm={{ span: 0 }} xl={{ span: 24 }} xs={{ span: 0 }}>
            <Row className={`${RoadsideStyle["margin-bottom-12"]}`}>
              <p style={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}>
              {state === "PA" || state === "MI" || state === "NJ" ?
                <Text className="state-title" style={{ fontWeight: "700", fontStyle: "normal", color: "black", textTransform: "uppercase", textDecoration: "none", fontFamily: "GlacialInDifferenceBold", fontSize: "22px"}}>{getFullState(state)}</Text>
                :
                <Text className={`${RoadsideStyle["subtitle"]}`}>How does it work?</Text>  
              }
                <Text style={{ fontSize: "14px", lineHeight: "1.12em", marginRight: "0", fontFamily: "raleway", fontWeight: "400", textAlign: "left", marginLeft: "6px" }}>
                  {state === "PA" || state === "MI" ? "(For policies with effective date on or after 5/15/2024)" : "(For policies with effective date on or after 9/20/2024)"}
                </Text>
              </p>
              <Text className={`${RoadsideStyle["text"]}`}>
                When the unexpected happens, you're covered 24/7 with CURE Roadside Assistance. Call{' '}
                <a href="tel:8665221991" style={{ color: "#2a5a9b"}}>866-522-1991</a> and a representative will send help!{' '}
              </Text>
              <Text className={`${RoadsideStyle["text"]}`}>
                At CURE, coverage begins immediately and remains in effect until your policy expires or is terminated for
                any reason, including non-payment of premium. Emergency roadside services are limited to two claims in any
                six month term, and each claim is subject to your benefit limit of $125 per claim.
              </Text>
              {state === "PA" || state === "MI" || state === "NJ" ? <Text className={`${RoadsideStyle["text"]}`}>
                    If your covered vehicle stops running due to a non-accident related event (such as a mechanical or
                    electrical breakdown), call our dedicated toll-free number, <a href="tel:8665221991" style={{ color: "#2a5a9b"}}>866-522-1991</a>, and a service provider
                    will be dispatched for the below services subject to terms and conditions of your policy.
                    &nbsp;<a style={{textDecoration: "underline", color: "#1890ff"}} href={getDocumentLink(state)} target="_blank">Click here to see all benefits included with your Roadside Assistance package.</a>
              </Text> :
              <Text className={`${RoadsideStyle["text"]}`}>
                If your covered vehicle stops running due to a non-accident related event (such as mechanical or electrical breakdown), call our dedicated toll-free number
                and a service provider will be dispatched for the following services subject to the terms and conditions of your policy:
              </Text>}
              {
                (state === "PA" || state === "MI" || state === "NJ") &&
                <>
                  <Text className={`${RoadsideStyle["text"]}`}>
                    Your "Roadside Assistance Representative" will advise you of the service cost and methods for payment prior
                    to dispatching the service provider. You will be responsible to pay the service provider directly at the time
                    the service is performed. Your Roadside Assistance Reimbursement Services allows you to be reimbursed up to
                    your benefit limit of $125 per claim, upon presentation of original paid receipt from the service provider.
                    Original paid receipt can be mailed to: Membership Services PO BOX 830008 Miami, FL 33283 with all required
                    information within 60 days of the date of the service. If you have any questions, please call Roadside
                    Assistance Services at <a href="tel:8665221991" style={{ color: "#2a5a9b"}}>866-522-1991</a>.
                  </Text>
                </>
              }

            </Row>
          </Col>
          <Col lg={{ span: 0 }} md={{ span: 24 }} sm={{ span: 24 }} xl={{ span: 0 }} xs={{ span: 24 }}>
            <Row className={`${RoadsideStyle["margin-bottom-12"]}`}>
              <p className="roadside-disclaimer-wrapper" style={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", flexWrap: "wrap" }}>
                {state === "PA" || state === "MI" || state === "NJ" ?
                  <Text className="state-title" style={{ fontWeight: "700", fontStyle: "normal", color: "black", textTransform: "uppercase", textDecoration: "none", fontFamily: "GlacialInDifferenceBold", fontSize: "22px"}}>{getFullState(state)}</Text>
                  :
                  <Text className={`${RoadsideStyle["subtitle"]} ${RoadsideStyle["mobile-text"]}`}>How does it work?</Text>  
                }
                <Text style={{ fontSize: "14px", lineHeight: "1.12em", marginRight: "0", fontFamily: "raleway", fontWeight: "400", textAlign: "left", marginLeft: "6px" }}>
                  {state === "PA" || state === "MI" ? "(For policies with effective date on or after 5/15/2024)" : "(For policies with effective date on or after 9/20/2024)"}
                </Text>
              </p>
              <Text className={`${RoadsideStyle["text"]}`}>
                When the unexpected happens, you're covered 24/7 with CURE Roadside Assistance. Call{' '}
                <a href="tel:8665221991" style={{ color: "#2a5a9b" }}>
                  866-522-1991
                </a>{' '}
                and a representative will send help!{' '}
              </Text>
              <Text className={`${RoadsideStyle["text"]}`}>
                At CURE, coverage begins immediately and remains in effect until your policy expires or is terminated for
                any reason, including non-payment of premium. Emergency roadside services are limited to two claims in any
                six month term, and each claim is subject to your benefit limit of $125 per claim.
              </Text>
              {state === "PA" || state === "MI" || state === "NJ" ?<Text className={`${RoadsideStyle["text"]}`}>
                    If your covered vehicle stops running due to a non-accident related event (such as a mechanical or
                    electrical breakdown), call our dedicated toll-free number, <a href="tel:8665221991" style={{ color: "#2a5a9b"}}>866-522-1991</a>, and a service provider
                    will be dispatched for the below services subject to terms and conditions of your policy.
                    &nbsp;<a style={{textDecoration: "underline", color: "#1890ff"}} href={getDocumentLink(state)} target="_blank">Click here to see all benefits included with your Roadside Assistance package.</a>
              </Text> :
              <Text className={`${RoadsideStyle["text"]}`}>
                If your covered vehicle stops running due to a non-accident related event (such as mechanical or electrical breakdown), call our dedicated toll-free number
                and a service provider will be dispatched for the following services subject to the terms and conditions of your policy:
              </Text>}
              {
                (state === "PA" || state === "MI" || state === "NJ") &&
                <>
                  <Text className={`${RoadsideStyle["text"]}`}>
                    Your "Roadside Assistance Representative" will advise you of the service cost and methods for payment prior
                    to dispatching the service provider. You will be responsible to pay the service provider directly at the time
                    the service is performed. Your Roadside Assistance Reimbursement Services allows you to be reimbursed up to
                    your benefit limit of $125 per claim, upon presentation of original paid receipt from the service provider.
                    Original paid receipt can be mailed to: Membership Services PO BOX 830008 Miami, FL 33283 with all required
                    information within 60 days of the date of the service. If you have any questions, please call Roadside
                    Assistance Services at <a href="tel:8665221991" style={{ color: "#2a5a9b"}}>866-522-1991</a>.
                  </Text>
                </>
              }
            </Row>
          </Col>
          <Row className={`${RoadsideStyle["roadside-carousel"]} ${RoadsideStyle["margin-bottom-12"]}`}>
            <AliceCarousel
              animationDuration={800}
              autoPlay={!isMobile}
              autoPlayDirection="ltr"
              autoPlayInterval={3000}
              autoPlayStrategy="default"
              controlsStrategy="alternate"
              disableAutoPlayOnAction={true}
              disableButtonsControls={isMobile}
              disableDotsControls={isMobile}
              fadeOutAnimation={true}
              items={list}
              mouseTrackingEnabled={true}
              responsive={ROADSIDE_ASSISTANCE_BREAK_POINTS}
              {...(!isMobile && { infinite: true })}
            />
          </Row>
        </div>
      </>
    </>
  )
}

RoadsideAssistanceContent.propTypes = {}

export default RoadsideAssistanceContent;